module.exports = {"id":"223926","name":"Samuel Bastien","rating":"72","photo":"./data/images/photos/3/223926.png","club":{"name":"Chievo Vérone","logo":"./data/images/clubs/ChievoVerone.png"},"positions":["MC","MOC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SamuelBastien0.json
// module id = 3806
// module chunks = 0